import SnippetForm from './snippetForm.container';

export default SnippetForm;
